function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import _ from 'underscore';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormGroup, Label, ModalHeader, Input, Modal, Button, ModalBody, ModalFooter } from 'reactstrap';
import * as ajax from '../../actions/ajax';
import store from '../../reducers/storeRegistration';
import loginActions from '../../actions/loginActionCreators';
import DateTimePicker from '../common/controls/dateTimePicker';
import ApprovalSignatureField from './approvalSignatureField';

/* list out all the actions and their relevant attributes. */
const actions = {
  Reject: {
    text: 'Please enter a rejection note.',
    status: 'Rejected'
  },
  Approve: {
    text: 'Are you sure you want to approve this report? You will not ' + 'be able to edit it once it is approved.',
    status: 'Approved'
  },
  Process: {
    text: 'Are you sure you want to mark this report Processed?',
    status: 'Processed'
  },
  Submit: {
    text: 'Are you sure you want to submit this report?',
    status: 'Submitted'
  },
  Delete: {
    text: 'Are you sure you want to delete this report?',
    status: 'Deleted'
  }
};

/*
 * This checks to see if we are acting on multiple reports or a single
 * report.  If multiple, we need to modify the text to reflect that.
 */
const pluralizeText = singular => {
  let result = singular;
  // need to change text from 'this report' to 'these reports'
  result = result.replace('this report', 'these reports');
  // this is used in the approve action.  I could add it there, but in case
  // we end up resuing some verbiage like this and/or to keep all this
  // pluralization in the same place.
  result = result.replace('it once it is', 'them once they are');
  return result;
};
export default class ReportActionModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      note: '',
      nextInspection: null,
      sigIsUploading: false,
      signaturePath: null,
      signatureUrl: null
    };
    this.handleAction = this.handleAction.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleNextInspection = this.handleChange.bind(this, 'nextInspection');
    this.handleNote = this.handleChange.bind(this, 'note');
    this.handleSignature = this.handleChange.bind(this, 'signaturePath');
  }
  componentDidMount() {
    const {
      actionText
    } = this.props;
    if (actionText === 'Approve') {
      this.getUserSignature();
    }
  }
  async getUserSignature() {
    // Checks if user has a signature already and displays if they do
    const currentUserUrl = '/lookup/CurrentUser';
    try {
      const response = await ajax.get(currentUserUrl);
      if (response.data.signatureUrl) {
        this.setState({
          signatureUrl: response.data.signatureUrl
        });
      }
    } catch (e) {
      var _e$response;
      // If token expired (401), refresh and retry once
      if (((_e$response = e.response) === null || _e$response === void 0 ? void 0 : _e$response.status) === 401) {
        try {
          await store.dispatch(loginActions.serverToken());
          const response = await ajax.get(currentUserUrl);
          if (response.data.signatureUrl) {
            this.setState({
              signatureUrl: response.data.signatureUrl
            });
          }
        } catch (_unused) {
          // Retry failed, signature lookup is non-critical so continue silently
        }
      }
      // Non-401 errors are non-critical, continue silently
    }
    return null;
  }
  handleAction() {
    const {
      actionText,
      onAction
    } = this.props;
    const actionState = _objectSpread(_objectSpread({}, this.state), {}, {
      action: actionText
    });
    const {
      status
    } = actions[actionText];
    onAction(status, actionState);
  }
  handleChange(name, event) {
    const change = this.state;
    if (_.isUndefined(event) || _.isNull(event)) {
      change[name] = '';
    } else if (_.isUndefined(event.target)) {
      change[name] = event;
    } else {
      change[name] = event.target.value;
    }
    this.setState(change);
  }
  render() {
    const {
      actionText,
      onHide,
      pluralize
    } = this.props;
    const {
      note,
      signatureUrl,
      sigIsUploading,
      nextInspection
    } = this.state;
    let {
      text
    } = actions[actionText];
    if (pluralize) {
      text = pluralizeText(text);
    }
    const actionButtonIsDisabled = actionText === 'Approve' && sigIsUploading;
    const Body = /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(FormGroup, null, actionText === 'Approve' ? /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: '10px'
      }
    }, /*#__PURE__*/React.createElement(DateTimePicker, {
      onChange: this.handleNextInspection,
      label: "Next Inspection Date",
      value: nextInspection
    }), /*#__PURE__*/React.createElement(ApprovalSignatureField, {
      signatureUrl: signatureUrl,
      onChange: this.handleSignature,
      onUpload: value => this.setState({
        sigIsUploading: value
      }),
      style: {
        marginTop: '10px'
      }
    })) : undefined, /*#__PURE__*/React.createElement(Label, null, "Comment"), /*#__PURE__*/React.createElement(Input, {
      id: "actionForm",
      "data-testid": "t-ram-comment",
      type: "text",
      name: "note",
      value: note || '',
      onChange: this.handleNote
    })));
    return /*#__PURE__*/React.createElement(Modal, {
      isOpen: true,
      toggle: onHide,
      style: {
        position: 'absolute',
        top: '20%',
        left: '55%',
        transform: 'translate(-50%, -20%)',
        minWidth: '600px'
      },
      backdrop: "static"
    }, /*#__PURE__*/React.createElement(ModalHeader, {
      "data-testid": "ram-modal-header"
    }, text), actionText === 'Approve' || actionText === 'Reject' ? Body : undefined, /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
      className: "t-ram-button-cancel",
      onClick: onHide
    }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
      "data-testid": "t-ram-button-confirm",
      className: "t-ram-button-confirm",
      disabled: actionButtonIsDisabled,
      onClick: this.handleAction
    }, actionText)));
  }
}
ReportActionModal.defaultProps = {
  actionText: null,
  pluralize: false
};
ReportActionModal.propTypes = {
  // action text specs which report action to show.
  actionText: PropTypes.string,
  onAction: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
  pluralize: PropTypes.bool
};